import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Paper from "@material-ui/core/Paper/Paper";
import ParticipationForm from "../../components/Participations/ParticipationForm";
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import CardContent from "@material-ui/core/CardContent/CardContent";

const ParticipationsCreate = ({classes, course, persons, formUrl, preselectedHouse, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('participations.new_participant')}
            items={[
                {
                    icon: 'arrow_back',
                    text: i18n.get('participations.back'),
                    href: redirectAfterSubmit,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(redirectAfterSubmit);
                    },
                }
            ]}
        />

        <Paper>
            <CardContent>
                <ParticipationForm
                    course={course}
                    persons={persons}
                    formUrl={formUrl}
                    isEdit={false}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Paper>
    </Layout>
);

export default ParticipationsCreate;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/participations/Create.jsx